module.exports = __webpack_public_path__ + "93674398d934305bc624bef3a17cbd02.png";